import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'action',
    label: 'Action',
    sortable: false,
  },
  {
    name: 'result',
    label: 'Result',
    sortable: false,
  },
  {
    name: 'ipSource',
    label: 'IP',
    sortable: false,
  },
  {
    name: 'eventCreatedAt',
    label: 'Creation Date',
    sortable: false,
    filterModalPlacement: 'right',
  },
];

export const columnsLabels = {
  action: 'Action',
  result: 'Result',
  ipSource: 'IP',
  eventCreatedAt: 'Creation Date',
};

export const schema = {
  action: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  ipSource: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  result: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  eventCreatedAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['eventCreatedAtFrom', 'eventCreatedAtTo'],
  },
  eventCreatedAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  eventCreatedAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
};

export const filtersSchema = [
  {
    name: 'result',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'result',
        title: 'Successful',
        value: 'SUCCESSFUL',
      },
      {
        name: 'result',
        title: 'Failed',
        value: 'FAILED',
      },
    ],
  },
  {
    name: 'ipSource',
    type: FilterType.TEXT,
    placeholder: 'Enter IP...',
  },
  {
    name: 'eventCreatedAt',
    type: FilterType.DATE_RANGE,
    withoutCustomSelector: true,
  },
  {
    name: 'action',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter action...',
  },
];
